import { useContext } from 'react';

import { SpotlightActionsContext } from '../components/SpotlightContext';

/**
 * Returns only the registration functions.
 * Subscribes to SpotlightActionsContext, so it does NOT re-render when items change.
 */
export const useSpotlightActions = () => {
    const context = useContext(SpotlightActionsContext);

    if (!context) {
        throw new Error('useSpotlightActions must be used within SpotlightProvider');
    }

    return context;
};
